<div class="mb-2">
    <select class="custom-select" id="ClosedReasonCode_Park" [(ngModel)]="Model.ClosedReasonCode_Park" name="ClosedReasonCode_Park" (change)="onParkReasonChange()">
        <option [value]="0" translate>CMB_DEF.CMB_DEF_SELECT_PARK_REASON</option>
        <option *ngFor="let row of masterService.GetReasonTypes(Model.PropertyId, 'PRKR')" [value]="row.ID">{{row.Description}}</option>
    </select>
</div>

<div class="row align-items-center no-gutters mb-2">
    <div class="col-4">
        <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" name="ReOpenTimeType" id="ReOpenTimeType_1" class="custom-control-input" [value]="1" [(ngModel)]="ReOpenTimeType">
            <label class="custom-control-label" for="ReOpenTimeType_1" translate>LBL.REOPEN_ON</label>
        </div>
    </div>
    <div class="col mr-1">
        <p-calendar name="ReopenTime" [(ngModel)]="Model.ReopenTime" [disabled]="ReOpenTimeType != 1" placeholder="{{'PH.PH_YYYY_MM_DD_SLASH' | translate}}" dateFormat="yy/mm/dd" showTime="true" hourFormat="24" showIcon="true" hideOnDateTimeSelect="true"></p-calendar>
    </div>
</div>

<div class="row align-items-center no-gutters">
    <div class="col-4">
        <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" name="ReOpenTimeType" id="ReOpenTimeType_2" class="custom-control-input" [value]="2" [(ngModel)]="ReOpenTimeType">
            <label class="custom-control-label" for="ReOpenTimeType_2" translate>LBL.REOPEN_AFTER</label>
        </div>
    </div>
    <div class="col mr-1">
        <div class="input-group">
            <input type="text" mask="000" name="afterDays" [(ngModel)]="Days" class="form-control" placeholder="{{'PH.PH_DAYS' | translate}}" [disabled]="ReOpenTimeType != 2" (ngModelChange)="onTimeChange()" />
            <input type="text" mask="00" name="afterHours" [(ngModel)]="Hrs" class="form-control" placeholder="{{'PH.PH_HRS' | translate}}" [disabled]="ReOpenTimeType != 2" (ngModelChange)="onTimeChange()" />
            <input type="text" mask="00" name="afterMins" [(ngModel)]="Mins" class="form-control" placeholder="{{'PH.PH_MINS' | translate}}" [disabled]="ReOpenTimeType != 2" (ngModelChange)="onTimeChange()" />
        </div>
    </div>
</div>


